import React, { useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { fetchOrder } from '../../../../actions/order/orderDetail'
import { fetchOrderStatuses } from '../../../../actions/order/orderStatuses'
import { OrderDetails, OrderStatuses } from '..'
import { AppState } from '../../../../reducers'
import { OrderDetailState } from '../../../../reducers/order/orderDetail'
import { useTranslation } from 'react-i18next'
import { Paper, Box, CircularProgress, Link, Typography, Table, TableBody, TableCell, TableHead, TableRow, Avatar, Button, Stack, Tooltip } from '@mui/material';
import { ISTableTitle, ISTableRow, ISTableHeaderCell } from '../../../Utils/ISTable';
import { FileDownloadOutlined, KeyboardReturnOutlined, LaunchOutlined } from '@mui/icons-material';
import moment from 'moment';
import { OrderStatusesState } from '../../../../reducers/order/orderStatuses'
import { formattedCurrency } from '../../../../utils/StringUtils'
import { useThemeContext } from '../../../../theme/ThemeContext'
import { statusOrder, tableToStatusOrder } from '..'
import { SessionState, isClient } from '../../../../reducers/auth/session'
import { getToken } from '../../../../utils/fetchApi'
import { useState } from 'react';
import requestAction from '../../../../utils/requestAction'
import { roleToURLPrefix } from '../../../../App'
import { PERSON } from '../../../../models/User'
import { RemittanceListState } from '../../../../reducers/remittance/remittanceList'
import { fetchRemittances } from '../../../../actions/remittance/remittanceList'

export const SearchUnigisForm: React.FC = () => {
  const [reference, setReference] = useState<string>('');
  const [result, setResult] = useState<string | null>(null);
  const dispatch = useDispatch()

  // Función para manejar el envío del formulario
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();


    try {

      dispatch(
        requestAction('UNIGIS')(
          `unigis`,
          'POST',
          {
            searchReference: reference,
            UTC_difference: '-180'
          },
          undefined,
          undefined,
          (_dispatch, _getState, response) => {
            // Crear un contenedor en memoria para analizar el HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(response.htmlContent, 'text/html');

            // Extraer el href
            const href = doc.querySelector('a')?.getAttribute('href');

            // Mostrar el resultado
            setResult(`${process.env.REACT_APP_UNIGIS_HOST}${href}`) //https://cloud-test.unigis.com${href}
          }))

    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
    }
  };

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <label htmlFor="searchReference">Buscar Referencia:</label>
        <input
          type="text"
          id="searchReference"
          name="searchReference"
          value={reference}
          onChange={(e) => setReference(e.target.value)}
        />
        <button type="submit">Buscar</button>
      </form>

      {result && <Link href={result} target="_blank">seguimiento</Link>}
    </div>
  );
};

interface Props {
  orderDetail: OrderDetailState
  orderStatuses: OrderStatusesState
  remittanceList: RemittanceListState
  session: SessionState
}

const OrderDetail: React.FC<Props> = ({ orderDetail, orderStatuses, remittanceList, session }) => {
  const dispatch = useDispatch()
  const params = useParams<{ orderId: string, clientId?: string }>()
  const history = useHistory()
  const { t } = useTranslation(['order', 'others'])
  const { theme } = useThemeContext()

  const handleUnigis = async (reference: string) => {
    try {

      dispatch(
        requestAction('UNIGIS')(
          `unigis`,
          'POST',
          {
            searchReference: reference,
            UTC_difference: '-180'
          },
          undefined,
          undefined,
          (_dispatch, _getState, response) => {
            // Crear un contenedor en memoria para analizar el HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(response.htmlContent, 'text/html');

            // Extraer el href
            const href = doc.querySelector('a')?.getAttribute('href');

            window.open(
              `${process.env.REACT_APP_UNIGIS_HOST}${href}`,
              '_blank'
            );
          }))

    } catch (error) {
      console.error('Error al enviar la solicitud:', error);
    }
  };


  useEffect(() => {
    dispatch(fetchOrder(params.orderId, params.clientId, history.location.search))
    dispatch(fetchOrderStatuses(params.orderId, history.location.search))
    dispatch(fetchRemittances(`?id_pedido=${params.orderId}${params.clientId ? `&codigo_cliente=${params.clientId}` : ''}`))
  }, [dispatch, params.orderId, params.clientId, history.location.search])

  const linkToPrepaymentDetail = (prepaymentId: string) => {
    const detailUrl = `/${session.roles && roleToURLPrefix(session.roles.filter(role => role !== PERSON)[0])}/prepayments/detail/${prepaymentId}`
    history.push(detailUrl)
  }


  const HeaderDetail: React.FC = () => {

    return (
      <Paper elevation={2} sx={{ margin: "10px", padding: "2px 2px 2px 2px", bgcolor: theme.palette.success.main }}>
        <Paper elevation={2}
          style={{
            padding: "15px 15px 15px 15px", display: "flex", flexDirection: "column",
            textAlign: "justify", justifyContent: "space-around",
            borderRadius: "4px", margin: "4px"
          }}>
          {orderStatuses.order && orderStatuses.order.length > 0 &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('number')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{orderStatuses.order[0].pedido_numero}</Typography>
              </Box>
              {orderStatuses.order[0].estados && orderStatuses.order[0].estados.length > 0 && orderStatuses.order[0].estados[orderStatuses.order[0].estados.length - 1].estado_pedido &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('status')}:&nbsp;&nbsp;</Typography>
                  <Avatar sx={{
                    color: theme.palette.success.dark,
                    backgroundColor: theme.palette.success.main
                  }}>
                    {statusOrder(tableToStatusOrder(orderStatuses.order[0].estados[orderStatuses.order[0].estados.length - 1].estado_pedido, orderStatuses.order[0].codigo_transporte)).icon}
                  </Avatar>
                  <Typography variant="h6">&nbsp;&nbsp;{t(`${statusOrder(tableToStatusOrder(orderStatuses.order[0].estados[orderStatuses.order[0].estados.length - 1].estado_pedido, orderStatuses.order[0].codigo_transporte)).name}`)}</Typography>
                </Box>
              }
              {orderDetail.orderLines && orderDetail.orderLines.length > 0 && orderDetail.orderLines[0].id_acopio &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('prepayment')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">{orderDetail.orderLines[0].id_acopio}&nbsp;&nbsp;</Typography>
                  <LaunchOutlined sx={{ cursor: 'pointer', color: theme.palette.success.main }}
                    onClick={() => linkToPrepaymentDetail(orderDetail.orderLines && orderDetail.orderLines.length > 0 && orderDetail.orderLines[0].id_acopio ? orderDetail.orderLines[0].id_acopio : '')} />
                </Box>}
              {orderDetail.orderLines && orderDetail.orderLines.length > 0 &&
                <Box display="flex" alignItems="center">
                  <Typography fontWeight="bold" variant="h6">{t('totalSum')}:&nbsp;&nbsp;</Typography>
                  <Typography variant="h6">{formattedCurrency(orderDetail.orderLines.reduce((neto, order) => neto + Number(order.importe), 0))}</Typography>
                </Box>}

              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="h6">{t('total')}:&nbsp;&nbsp;</Typography>
                <Typography variant="h6">{formattedCurrency(orderStatuses.order[0].importe_total_comprobante)}</Typography>
              </Box>
            </Box>}
          {orderStatuses.order && orderStatuses.order.length > 0 && !isClient(session) &&
            <Box display="flex" justifyContent="space-between" alignItems="center">
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="body1">{t('deliveryDate')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{moment(orderStatuses.order[0].fecha_estimada_entrega).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="body1">{t('carrier')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{`[${orderStatuses.order[0].codigo_transporte}]  ${orderStatuses.order[0].nombre_transporte}`}</Typography>
              </Box>
              <Box display="flex" alignItems="center">
                <Typography fontWeight="bold" variant="body1">{t('deliveryArea')}:&nbsp;&nbsp;</Typography>
                <Typography variant="body1">{`[${orderStatuses.order[0].codigo_zonadereparto}]  ${orderStatuses.order[0].descripcion_zonadereparto}`}</Typography>
              </Box>
            </Box>}
          {remittanceList && remittanceList.remittances && remittanceList.remittances.length > 0 &&
             <Box display="flex" alignItems="center">
              <Typography fontWeight="bold" variant="body1">&nbsp;&nbsp;</Typography>
            </Box>}
            {remittanceList && remittanceList.remittances && remittanceList.remittances.length > 0 &&
            <Box display="flex" justifyContent="flex-start" alignItems="center">
              <Typography fontWeight="bold" variant="body1">{t('remittances')}:&nbsp;&nbsp;</Typography>
              <Box display="flex" justifyContent="flex-start" alignItems="center" flexWrap="wrap">
              {remittanceList.remittances.map(remittance =>
                <Typography display="flex" alignItems="center">
                  {moment(remittance.fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}&nbsp;-&nbsp;{remittance.id_remito}&nbsp;
                  {(!session.isChaco && !orderDetail.isChacoClient ) && <Tooltip title={t('followUnigis')}>
                  <LaunchOutlined sx={{ cursor: 'pointer', color: theme.palette.success.main }}
                    onClick={(e: React.FormEvent) => { e.preventDefault(); handleUnigis(remittance.id_remito)}} />
                  </Tooltip>}
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </Typography>
              )}
            </Box>  
            </Box>}
        </Paper>
      </Paper>
    )
  }
  
  return (
    <Stack style={{ display: 'flex', flexDirection: 'column', maxHeight: 'calc(90% - var(--header-height)' }}>
      {!orderDetail.isFetching && !orderStatuses.isFetching && <HeaderDetail />}
      {!orderDetail.isFetching && !orderStatuses.isFetching &&
      <Stack style={{ borderRadius: "10px", margin: "10px", minWidth: "500px" }}>
        <ISTableTitle title={t('titleStatus')} />
        <Table size="medium" >
          <TableHead>
            <TableRow selected={true}>
              <ISTableHeaderCell align='center'>{t('date')}</ISTableHeaderCell>
              <ISTableHeaderCell align='center'>{t('number')}</ISTableHeaderCell>
              <ISTableHeaderCell align='center'>{t('status')}</ISTableHeaderCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!orderStatuses.isFetching && orderStatuses.order && orderStatuses.order.length > 0 &&
              <ISTableRow key={orderStatuses.order[0].id_pedido} color='default'>
                <TableCell align='center'>{moment(orderStatuses.order[0].fecha).tz("America/Argentina/Buenos_Aires").format('DD/MM/YYYY')}</TableCell>
                <TableCell align='center'>{orderStatuses.order[0].pedido_numero}</TableCell>
                <OrderStatuses row={orderStatuses.order[0]} showDate={false} isChaco={session.isChaco || orderDetail.isChacoClient}  />  {/*!isClient(session)} />*/}
              </ISTableRow>}
            {orderStatuses.isFetching &&
              <ISTableRow key='fetching' color='default'>
                <TableCell align='center'></TableCell>
                <TableCell align='center'><CircularProgress size={25} /></TableCell>
                <TableCell align='center'></TableCell>
              </ISTableRow>
            }

          </TableBody>
        </Table>
      </Stack>}
      <OrderDetails
        rows={(orderDetail.orderLines || []).sort((a, b) => a && b ? a.codigo_articulo > b.codigo_articulo ? 1 : -1 : 0).map(s => ({ data: s }))}
        loading={orderDetail.isFetching || orderStatuses.isFetching}
        titleStatus={orderStatuses && orderStatuses.order && orderStatuses.order.length > 0 &&
          orderStatuses.order[0].estados && orderStatuses.order[0].estados.length > 0 ? orderStatuses.order[0].estados[0].estado_pedido.toLowerCase().includes('entregado') ? t('deliveredPieces') : t('toDeliverPieces') : t('toDeliverPieces')}
        pagination={orderDetail.pagination || undefined}
        isChaco={session.isChaco || orderDetail.isChacoClient}
        toDeliver={orderStatuses && orderStatuses.order && orderStatuses.order[0].estados && orderStatuses.order[0].estados?.length > 0 && 
            (!orderStatuses.order[0].estados[0].estado_pedido.toLocaleLowerCase().includes('entregado') && !orderStatuses.order[0].estados[0].estado_pedido.toLocaleLowerCase().includes('ingresado')) }
      />
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Button color="secondary" variant="contained" sx={{ textTransform: "none", margin: "10px" }} startIcon={<KeyboardReturnOutlined />} onClick={() => history.goBack()}>{t("back", { ns: 'others' })}</Button>
        {orderDetail && orderDetail.orderLines && orderDetail.orderLines.length > 0 &&
          <Tooltip title={t('downloadingOrder')}>
            <span>
              <Button variant="contained" sx={{ textTransform: "none", margin: "10px" }}
                startIcon={<FileDownloadOutlined />}
                href={`${process.env.REACT_APP_API_URL}/orders/download/${orderDetail.orderLines[0].id_pedido.trimEnd()}?access_token=${getToken()}`} target="_blank">
                {t("downloadOrder")}
              </Button>
            </span>
          </Tooltip>
        }
      </Box>
    </Stack>
  )
}

const mapStateToProps = (state: AppState) => ({
  orderDetail: state.orderDetail,
  orderStatuses: state.orderStatuses,
  remittanceList: state.remittanceList,
  session: state.session
})


export default connect<Props, {}, {}, AppState>(mapStateToProps, {})(OrderDetail);